<template>
    <BlogList
        :categories="data?.postCategories"
        :posts="data?.posts"
        :total-posts="data?.postsAggregation.count"
        :description="data?.pageByPath?.meta.description"
        :error
        :fetching
        :has-data="!!data"
        :meta-title="data?.pageByPath?.meta.title"
        :page
        :response-errors
        :stale
        :title="data?.pageByPath?.title"
        @try-again="executeQuery"
    >
        <template #blocks>
            <CmsBlocks
                v-if="data?.pageByPath?.blocks.length"
                :data="data.pageByPath.blocks"
                page-type="post"
            />
        </template>
    </BlogList>
</template>

<script lang="ts" setup>
import { computed, provide } from 'vue'

import { type BlogQueryVariables } from '@/graphql/api'
import { useTranslator } from '@/i18n'
import { useCountryPlugin } from '@/plugins/country.ts'
import { useResponseError } from '@/helpers/errors'
import { useCurrencyInput } from '@/plugins/currency-input.ts'
import { useBlogQuery } from './Blog.generated.ts'

import BlogList from '@/components/cms/component/blog/BlogList.vue'
import CmsBlocks from '@/components/cms/CmsBlocks.vue'
import { useBlogFeedLink } from '@/views/blog/composables/useBlogFeedLink.ts'

const { page } = defineProps<{
    page: number
}>()

const { locale } = useTranslator()
const currency = useCurrencyInput()
const { countryCode } = useCountryPlugin()

useBlogFeedLink()

const variables = computed((): BlogQueryVariables => {
    return {
        path: '/blog',
        page: page,
        limit: 10,
        locale: locale.value,
        currency: currency.value,
        country: countryCode.value!,
    }
})

// TODO set 404 status if not found
const response = useBlogQuery({ variables })
provide('response', response)

await response

const responseErrors = useResponseError(response)

const { fetching, data, error, stale, executeQuery } = response
</script>
